import { t } from '@lingui/macro'
import { isAuthorized } from 'helpers'

export const getBookingRoutes = (userRoles, navigate) => {
  const has_roomplanner = isAuthorized(userRoles, [
    'room_planner',
    'event_planner',
    'staff_planner',
    'admin'
  ])
  // const has_eventplanner = isAuthorized(userRoles, ['event_planner', 'admin'])
  // const has_staffplanner = isAuthorized(userRoles, ['staff_planner', 'admin'])
  // const has_checkin = isAuthorized(userRoles, ['check_in', 'admin'])
  // const has_premierplanner = isAuthorized(userRoles, ['premier', 'admin'])
  // const has_employee = isAuthorized(userRoles, ['employee', 'admin'])
  // const has_settings = isAuthorized(userRoles, [
  //   'admin',
  //   'staff_planner',
  //   'event_planner',
  //   'room_planner'
  // ])

  return [
    ...(has_roomplanner
      ? [
          {
            path: '/booking/introduction',
            label: t`Introduction`,
            onClick: path => navigate(path)
          },
          {
            path: '/booking/calendar/today/week',
            label: t`Calendar`,
            onClick: path => window.location.assign(path)
          },
          {
            path: '/booking/roombookings',
            label: t`Bookings`,
            onClick: path => navigate(path)
          },
          // {
          //   path: '/booking/setup',
          //   label: i18n._(t`Settings`),
          //   // onClick: has_settings ? undefined : path => navigate(path),
          //   pages: has_settings
          //     ? [
          {
            path: '/booking/setup/rooms/1',
            label: t`Rooms`,
            onClick: path => navigate(path)
          },
          {
            path: '/booking/setup/roomgroups/1',
            label: t`Room Groups`,
            onClick: path => navigate(path)
          },
          {
            path: '/booking/setup/fieldgroups',
            label: t`Fields`,
            onClick: path => navigate(path)
          },
          {
            path: '/booking/setup/bookingtypes',
            label: t`Booking types`,
            onClick: path => navigate(path)
          },
          {
            path: '/booking/setup/addresses/1',
            label: t`Addresses`,
            onClick: path => navigate(path)
          }
          // {
          //   path: '/booking/setup/elektrasettings',
          //   label: i18n._(t`Scenes`),
          //   onClick: path => navigate(path)
          // }
          // ]
          //         : []
          //     }
        ]
      : [])
  ]
}
